/* Native scrolling still works when JS is unavailable. No autoplay or wheel hijacking. */
(() => {
  const setup = (root) => {
    if (root.dataset.worksReady) return;
    root.dataset.worksReady = 'true';
    const rail = root.querySelector('[data-works-rail]');
    if (!rail) return;
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const buttons = [...root.querySelectorAll('[data-step]')];
    buttons.forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => rail.scrollBy({left:Number(button.dataset.step) * rail.clientWidth * .75,behavior:motion()}));
    });
    const dots = [...root.querySelectorAll('[data-slide]')];
    const slides = [...rail.querySelectorAll('.nk-work__slide')];
    dots.forEach((dot,i) => dot.addEventListener('click', () => {
      const slide = slides[i];
      rail.scrollTo({left:slide.offsetLeft - rail.offsetLeft - (rail.clientWidth-slide.clientWidth)/2,behavior:motion()});
    }));
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      buttons.forEach(b => b.disabled = Number(b.dataset.step)<0 ? rail.scrollLeft<=2 : rail.scrollLeft>=max-2);
      if (slides.length) {
        const center = rail.getBoundingClientRect().left + rail.clientWidth/2;
        let nearest = 0, distance = Infinity;
        slides.forEach((s,i) => {const rect=s.getBoundingClientRect(), d=Math.abs(rect.left+rect.width/2-center);if(d<distance){distance=d;nearest=i;}});
        dots.forEach((d,i) => {if(i===nearest)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current');});
      }
    };
    let frame;
    rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(sync);},{passive:true});
    rail.addEventListener('keydown',e => {
      if(e.target!==rail||!['ArrowLeft','ArrowRight'].includes(e.key)) return;
      e.preventDefault();rail.scrollBy({left:(e.key==='ArrowRight'?1:-1)*rail.clientWidth*.75,behavior:motion()});
    });
    // Demo filtering uses the same complete collection; real blogs use server-side tag URLs.
    const cards=[...rail.querySelectorAll('[data-category]')];
    root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{
      root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
      let visible=0;
      cards.forEach(c=>{c.hidden=b.dataset.filter!=='all'&&!c.dataset.category.split('|').includes(b.dataset.filter);if(!c.hidden){visible++;}});
      const count=root.querySelector('[data-count]');if(count)count.textContent=visible+' projects';
      rail.scrollTo({left:0,behavior:'auto'});sync();
    }));
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
    rail.querySelectorAll('img').forEach(img=>img.addEventListener('load',sync,{once:true}));
    sync();
  };
  const init = scope => scope.querySelectorAll('[data-works]').forEach(setup);
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
